import { centerable as t } from "../decorators/centerable.js";
import { uploadable as l } from "../decorators/uploadable.js";
import { BLOCK_CLASSES as e } from "../../constants.js";
import "../../bundled_deps/.pnpm/tinycolor2@1.6.0/bundled_deps/tinycolor2/esm/tinycolor.js";
const s = t(
  l({
    inline: !1,
    draggable: !0,
    attrs: {
      type: { default: "audioFile" },
      url: { default: "" }
    },
    group: "block",
    parseDOM: [
      {
        tag: ".intercom-interblocks-audio-file",
        getAttrs(r) {
          return {
            url: r.querySelector("audio").getAttribute("src")
          };
        }
      },
      {
        tag: ".embercom-prosemirror-composer-block-container.embercom-prosemirror-composer-audio audio",
        getAttrs(r) {
          return {
            url: r.querySelector("source").getAttribute("src")
          };
        }
      }
    ],
    toDOM(r) {
      return [
        "div",
        {
          class: `${e.blockContainer} ${e.audio}`
        },
        [
          "audio",
          {
            class: "block-audio-file-player",
            controls: "",
            controlsList: "nodownload nofullscreen noremoteplayback noplaybackrate",
            src: r.attrs.url,
            style: "width: 100%;"
          }
        ]
      ];
    }
  })
);
export {
  s as audioFileSpec
};
